import "@reach/combobox/styles.css";

import {GetSelectedLayers, getLayers, getSelectedWalk} from './lib/preferences';
import React, { Component } from 'react';

import {
GoogleMap,
} from "@react-google-maps/api";
import MapCenter from './MapCenter';
import MyLocation from './MyLocation';
import Pin from './Pin';
import getNearby from './lib/getNearby';
import isDev from './lib/isDev';

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false, // set to true when a fetch is in progress
      idleEvent: null, // used to cancel `idle` event listener
      localGeo: false,
      myCenter: this.defaultCenter,
      mapCenter: this.defaultCenter,
      panning: false,
      timer: null,     // fetch timer
      inStreetviewMode: false,

    };
    this.handleIdle = this.handleIdle.bind(this);
    //this.handleStreetview = this.bind(this)
    this.logError = this.logError.bind(this);
    this.makeFirstFetch = this.makeFirstFetch.bind(this);
    this.newCenter = this.newCenter.bind(this);
    this.newNearbyPlaces = this.newNearbyPlaces.bind(this);
    this.panToCenter = this.panToCenter.bind(this);
    this.panToCenterReset = this.panToCenterReset.bind(this);
    this.watch = this.watch.bind(this);
//    this.setStreetviewMode = this.setStreetviewMode.bind(this);
  }


  // defaultCenter = { // Guildhall Yard
  //   lat: 51.515595,
  //   lng: -0.092255
  // };

  defaultCenter = { // Bang on top of tYe Olde Wattling
    lat: 51.512912750027,
    lng: -0.0935446757206416
  };

  defaultZoom = 18;

  logError(err) {
    // only log warnings in development
    if (isDev()) {
      console.warn('ERROR(' + err.code + '): ' + err.message)
    }
  }

  watch() {
    const { localGeo } = this.state;
    if (localGeo) {
      navigator.geolocation.watchPosition(this.newCenter, this.logError)
    }
  }
  renderWalk(selectedWalk) {
    var legs = selectedWalk.points;
    if (legs === undefined) {
      return
    }
    var googleMap = window["google"]
    const { map } = this.state;

    var polyline = new googleMap.maps.Polyline({
      path: [],
      strokeColor: '#FF0000',
      strokeWeight: 3
    });
    var bounds = new googleMap.maps.LatLngBounds();


    var i = 0;
    for (i = 0; i < legs.length; i++) {

      var pt = new googleMap.maps.LatLng(parseFloat(legs[i].lat), parseFloat(legs[i].lon))
      polyline.getPath().push(pt);
      bounds.extend(pt);

    }
    polyline.setOptions({ zIndex: 200 });

    polyline.setMap(map);
    map.fitBounds(bounds);
  }
  // coming from navigator.geolocation.watchPosition
  newCenter(loc) {
    const { latitude, longitude } = loc.coords;
    const { userHasPanned } = this.props;

    // set user center
    this.setState({
      myCenter: {
        lat: latitude,
        lng: longitude
      }
    });

    // only set map center if the user has not manually panned
    if (!userHasPanned) {
      this.setState({
        mapCenter: {
          lat: latitude,
          lng: longitude
        }
      });
    }

    // panToCenter will decide whether to pan based on whether the user
    // has manually panned
    this.panToCenter();
  }

  // augmentWithWalk() {
  //   const { places } = this.props;
  //   let walkStageCounter = 0;
  //   const walkData = getWalkStages()
  //   let i = 0;
  //   while (i < walkData.points.length) {
  //     let x = 0;
  //     while (x < places.length) {
  //       if (places[x].place_id === walkData.points[i])
  //         places[x].walkStageCounter = walkStageCounter++
  //       x++;
  //     }
  //     i++;
  //   }
  // }

  // when user stops manually panning the map, get places for
  // the new center
  handleIdle() {
    const { idleEvent, map } = this.state;
    var googleMap = window["google"]

    if (idleEvent !== null) googleMap.maps.event.removeListener(idleEvent);
    const latLng = map.getCenter();

    console.log('handleIdle  ' + latLng.lat() + ' ' + latLng.lng());


    this.setState({
      mapCenter: {
        lat: latLng.lat(),
        lng: latLng.lng()
      },
      panning: false
    });
    this.newNearbyPlaces();
  }

  setStreetviewMode(streetView){

    console.log('Marker inStreetviewMode ' + streetView);

    this.setState({
      inStreetviewMode: streetView
    })
  }

  makeFirstFetch() {
    const { map, timer } = this.state;
    const { setIsFirstFetch, setUserHasPanned } = this.props;

    setIsFirstFetch(false);

    // prevent infowindows from opening
    map.addListener('click', evt => { evt.stop() });

    // if user manually pans the map, stop watching for new locations
    map.addListener('dragstart', evt => {
      clearTimeout(timer);
      setUserHasPanned(true);
      this.setState({
        idleEvent: map.addListener('idle', this.handleIdle),
        panning: true
      });
    });

    // get first set of places
    this.newNearbyPlaces(true);
  }

  // where the map is centred right now, as {lat, lng} (null before the map has loaded)
  getMapCenter() {
    const { map } = this.state;
    if (!map) return null;
    const center = map.getCenter();
    return { lat: center.lat(), lng: center.lng() };
  }

  panToCenterReset(coordinate) {
    const { map } = this.state;
    if (map) {
      this.setState({
        idleEvent: map.addListener('idle', this.handleIdle),
        panning: true
      });
      console.log(coordinate.lat)
      console.log(coordinate.lng)
      map.panTo({ lat: parseFloat(coordinate.lat), lng: parseFloat(coordinate.lng) });
    }

  }

  panToCenter() {
    const { myCenter, map } = this.state;
    const { userHasPanned } = this.props;
    var googleMap = window["google"]

    if (map && googleMap.maps && !userHasPanned) {
      this.setState({
        idleEvent: map.addListener('idle', this.handleIdle),
        panning: true
      });
      map.panTo(new googleMap.maps.LatLng(myCenter.lat, myCenter.lng));
    }
  }

  // conditions under which we want to fetch new places:
  // 1. no setTimeout has been set
  // 2. not currently fetching
  // 3. either:
  //      user has panned
  //        ok to fetch right away
  //      user has not panned
  //        elapsed time since last fetch is greater than the fetch delay
  //        if not enough time has passed since the last fetch
  //            set a timeout to trigger a fetch once the remaining time has passed
  newNearbyPlaces(isFirstFetch) {
    const { fetching, mapCenter, timer } = this.state;
    const { fetchDelay, fetchRange, lastFetch, setLastFetch, setPlaces, userHasPanned } = this.props;

    const now = Date.now();

    const doFetch = () => {
      this.setState({
        fetching: true
      });
      clearTimeout(timer);

      setLastFetch(now);

      const sources = GetSelectedLayers()
      // the first fetch after a page load is a hard refresh for Hands-On Time,
      // so reloading the page always shows the latest clocks
      getNearby(mapCenter.lat, mapCenter.lng, fetchRange, sources, isFirstFetch)
        .then(json => {
          if (json.query && json.query.pages) {
            setPlaces(json.query.pages);
          }
        })
        .catch(this.logError)
        .finally(() => {
          this.setState({
            fetching: false
          });
        });
    };

    // bail early if we have a timer set or are currently doing a fetch
    if (timer || fetching) {
      return;
    }

    if (isFirstFetch) {
      doFetch();
    }
    else if (userHasPanned) {
      doFetch();
    }
    else {
      // convert to seconds to because fetchDelay is saved in seconds
      const elapsed = (now - lastFetch) / 1000;

      // elapsed time since last fetch is greater than the fetch delay
      if (elapsed > fetchDelay) {
        doFetch();
      }
      // not enough time has elapsed, so set a timer to fetch later
      else {
        // set timer for how much time is left, convert to milliseconds
        const remaining = (fetchDelay - elapsed) * 1000;

        this.setState({
          timer: setTimeout(() => {
            this.setState({
              timer: null
            });
            doFetch();
          }, remaining)
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { fetching, localGeo, map, panning, watcher } = this.state;
    const { apiLoaded, geo, userHasPanned, isFirstFetch } = this.props;
    var googleMap = window["google"]

    // should only ever fire once, on app load
    if (apiLoaded && map && googleMap.maps && isFirstFetch) {
      this.makeFirstFetch();
    }

    // start watching for location changes when the user grants
    // location access for the first time
    if (geo && !watcher && !localGeo) {
      this.setState({
        localGeo: true
      });
      window.requestAnimationFrame(this.watch);
    }

    // this gets hit a lot, but is basically a no-op if a fetch is
    // in progress or pending
    if (localGeo && !userHasPanned && !panning && !fetching) {
      this.panToCenter();
    }
  };

  renderPins(places) {
    const { setPlace } = this.props;
    const { setViewInfoOpen } = this.props;
    if (!places) return null;
    if (Object.keys(places).length === 0)
      return null;
    let walks = getSelectedWalk();
    let walkStageNumber = 0;
    const layers = getLayers();
    const pins = places.map(place => {
      const { pageid, coordinates, thumbnail } = place;
      let thumb;
      const layer = layers.find(l => l.id === place.source_id);
      const sourceKey = layer ? layer.key : undefined;
      let w1 = 0;
      while (w1 < walks.length){
        if (walks[w1].pageid === pageid) {
          walkStageNumber++
        }
      }
      if (thumbnail && thumbnail.source) {
        thumb = thumbnail.source;
      }
      if (coordinates.length > 0) {
        let { lat, lon } = coordinates[0];
        return (
          <Pin key={pageid}
            thumb={thumb}
            lat={lat}
            lng={lon}
            setPlace={setPlace}
            setViewInfoOpen={setViewInfoOpen}
            place_id={place.place_id}
            source_id={place.source_id}
            sourceKey={sourceKey}
            canonicalurl={place.canonicalurl}
            walkStageNumber={walkStageNumber}
            {...place}
          />
        );
      }
      else {
        return null;
      }
    });
    return pins;
  };

  onGoogleApiLoaded(map, maps) {
    const { setApiLoaded } = this.props;
    this.setState({ map, maps });
    var paramview = map.getStreetView()
    window.google.maps.event.addListener(paramview, 'visible_changed', () =>  {
      this.setStreetviewMode(paramview.getVisible())}
      );
    setApiLoaded(true);
  }
  render() {
    const { myCenter } = this.state;
    const { geo, places, userHasPanned } = this.props;
    const mapCenterClassnames = userHasPanned ?
      'map-center active'
      : 'map-center';

    const containerStyle = {
      width: '100%',
      height: '100%',
    };
    return (
      <div className="Map-container">

        <GoogleMap
          mapContainerStyle={containerStyle}
          zoom={this.defaultZoom}
          center={this.defaultCenter}
          onLoad={(map) => this.onGoogleApiLoaded(map)}
          onIdle={() => this.handleIdle()}
          yesIWantToUseGoogleMapApiInternals
          options={{
            fullscreenControl: false,
          }}
        >
          {this.renderPins(places)}
          {geo && <MyLocation lat={myCenter.lat} lng={myCenter.lng} />}
        </GoogleMap>
        <MapCenter classNames={mapCenterClassnames} />

      </div>
    );
  }
};

export default Map;
